import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterTagType_template} from "./filterTagType_template";

declare var ko: any;

export class configMyModules_template extends vnTemplate {

    protected tagTypeFilter: filterTagType_template;

    protected getTemplateHtml(): string{

        return `
            <div class="w-form" style="width: 65%">
                <div class="w-form-body">
                    <div class="form-header">
                       <h3 class="form-title icon i-article">My Modules</h3>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <div class="w-img-config-list">
                                 <div class="w-left" >
                                    <button class="btn secondary icon i-add" type="button" data-bind="click: onClickAdd">Add Module</button>
                                    <button class="btn secondary icon i-add" type="button" data-bind="click: onClickAddLabelNameForTagTypes">Label Name</button>
                                </div>
                            </div>
                        </div>
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>name</span></th>
                                    <th><span>nice name</span></th>
                                    <th><span>permalink</span></th>
                                    <th><span>max items</span></th>
                                    <th><span>list type</span></th>
                                    <th><span>image orientation</span></th>
                                    <th><span>tag types</span></th>
                                    <th><span>Edit</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: modules" id="config-item-list">
                                <tr class="img-config-item" data-bind="attr: {id: $index }">
                                    <td class="align-center">
                                        <div class="form-group">
                                            <span data-bind="text: name" class="title"></span>
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <div class="form-group">
                                            <span data-bind="text: niceName" class="title"></span>
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <div class="form-group">
                                            <span data-bind="text: permalink" class="title"></span>
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <div class="form-group">
                                            <span data-bind="text: maxItems" class="title"></span>
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <div class="form-group">
                                            <span data-bind="text: listType" class="title"></span>
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <div class="form-group">
                                            <span data-bind="text: imageOrientation" class="title"></span>
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <div class="form-group">
                                            <!-- ko if: tagTypes && tagTypes.length > 0 -->
                                                <span data-bind="text: tagTypes.map(t => t.name).join(', ')" class="title"></span>
                                            <!-- /ko -->
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <div class="w-btn" style="justify-content: center">
                                            <button class="btn only-icon border icon i-edit" type="button" data-bind="event: { click: $parent.onClickShowPopUp }"></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id="edit-dialog" class="w-lightbox light-theme">
                        <div class="lightbox-content module-edit">

                            <div class="w-form lightbox-form">
                                <div class="form-header">
                                    <h3 class="form-title" id="edit-module-title">Edit Module</h3>
                                    <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                                </div>

                                <div class="form-body" data-bind="if: moduleToEdit() !== null">
                                    <div class="form-group">
                                        <label class="form-label" >Module Name </label>
                                        <input class="input-text" type="text" data-bind="value: moduleToEdit().name, event: { change: onChangeModuleName }" placeholder="Enter a Module Name">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" >Module Nice Name </label>
                                        <input class="input-text" type="text" data-bind="value: moduleToEdit().niceName, event: { change: onChangeModuleNiceName }" placeholder="Enter a Module Nice Name">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" >Permalink </label>
                                        <input class="input-text" type="text" data-bind="enable: isNewModule(), value: moduleToEdit().permalink" placeholder="Enter a Permalink">
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label" >Max Items </label>
                                        <input class="input-text" type="number" data-bind="value: moduleToEdit().maxItems" />
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label" >List Type </label>
                                        <select style="width: 100%" data-bind="value: moduleToEdit().listType">
                                            <option value="numbered">Numbered</option>
                                            <option value="bullet" selected>Bullet</option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label" >Image Orientation </label>
                                        <select style="width: 100%" data-bind="value: moduleToEdit().imageOrientation">
                                            <option value="portrait" selected>Portrait</option>
                                            <option value="landscape">Landscape</option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Tag Type</label>
                                        ${this.tagTypeFilter.getHtmlBuild()}
                                        <div>
                                            <div data-bind="foreach: moduleToEdit().tagTypes">
                                                <div class="form-group">
                                                    <button class="btn-f-s icon i-x-after" type="button" data-bind="text: name, event: { click: $parent.onClickDeleteTagType }"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="form-footer">
                                    <button type="button" data-bind="event: { click: onClickDeleteModule }" class="btn">Delete</button>
                                    <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                                    <button type="button" data-bind="event: { click: onClickSaveEditValue }" class="btn highlight">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="label-name-dialog" class="w-lightbox light-theme" data-bind="css: { 'is-visible': labelNameDialogIsShow() }">
                        <div id="label-name-dialog-content" class="lightbox-content">
                            <div class="w-form lightbox-form">
                                <div class="form-header">
                                    <h3 class="form-title">Add Label Name for tag types</h3>
                                    <button type="button"  data-bind="event: { click: onClickHidePopUpForLabelName }" class="close-button icon i-close-2"></button>
                                </div>

                                <div class="form-body">
                                    <div class="form-group">
                                        <table class="list-action" style="width: 100%; margin:0;">
                                            <thead>
                                                <tr>
                                                    <th><span>ID</span></th>
                                                    <th><span>Name</span></th>
                                                    <th><span>Label Name</span></th>
                                                </tr>
                                            </thead>

                                            <tbody data-bind="foreach: tagTypesLabelMapping">
                                                <tr>
                                                    <td class="align-center">
                                                        <div class="form-group">
                                                            <span data-bind="text: $data.id" class="title"></span>
                                                        </div>
                                                    </td>
                                                    <td class="align-center">
                                                        <div class="form-group">
                                                            <span data-bind="text: $data.name" class="title"></span>
                                                        </div>
                                                    </td>
                                                    <td class="align-center" style="border-bottom:1px solid white;background:#d4edda;padding:.75rem;">
                                                        <div class="form-group" style="width: 100%">
                                                            <input style="width: 90%;border:none;background:white;padding:.5rem;border-radius:2px;" type="text" placeholder="label name" data-bind="value:$data.labelName" maxlength="7">
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="form-footer">
                                    <button type="button" data-bind="event: { click: onClickHidePopUpForLabelName }" class="btn">Cancel</button>
                                    <button type="button" data-bind="event: { click: onClickSaveLabelNameTagTypesMapping }" class="btn highlight">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-footer">
                    <button type="button" data-bind="event: { click: onClickCancel}" class="btn">Cancel</button>
                    <button type="button" data-bind="event: { click: onClickSave}" class="btn highlight">Save</button>
                </div>
            </div>


            `;
    }

    protected initPartial():void{

        this.tagTypeFilter = new filterTagType_template("tagTypeFilter", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{

        return "configMyModules_template";
    }

    protected buildViewModel(): any {

        let huit_neuf_this = this;

        const viewModel = {
            modules: ko.observableArray([]),
            permissions: ko.observableArray(this.initPermissions([])),
            editValue: ko.observable(null),
            test: ko.observable(0),
            moduleToEdit: ko.observable(null),
            isNewModule: ko.observable(false),
            tagTypesLabelMapping: ko.observableArray([]),
            cloneTagTypesLabelMapping: ko.observableArray([]),
            labelNameDialogIsShow: ko.observable(false),
            onClickSaveEditValue: (value, index, event) => huit_neuf_this.onClickSaveEditValue(),
            onClickSave: (value, index, event) => huit_neuf_this.onClickSave(),
            onClickCancel: (value, index, event) => huit_neuf_this.onClickCancel(),
            onClickAdd: () => huit_neuf_this.onClickAdd(),
            onClickAddLabelNameForTagTypes: () => huit_neuf_this.onClickAddLabelNameForTagTypes(),
            onClickSaveLabelNameTagTypesMapping: () => huit_neuf_this.onClickSaveLabelNameTagTypesMapping(),
            onClickHidePopUp: (data, event) => huit_neuf_this.onClickHidePopUp(),
            onClickShowPopUp: (data, event) => huit_neuf_this.onClickShowPopUp(data),
            onClickDeleteModule: (data, event) => huit_neuf_this.onClickDeleteModule(data),
            onClickDeleteTagType: (data, event) => huit_neuf_this.onClickDeleteTagType(data),
            onClickHidePopUpForLabelName: (data, event) => huit_neuf_this.onClickHidePopUpForLabelName(),
            onChangeModuleName: (data, event) =>{ huit_neuf_this.onChangeModuleName(data); },
            onChangeModuleNiceName: (data, event) =>{ huit_neuf_this.onChangeModuleNiceName(data); }
        };


        return { ...viewModel };
    }

    public getViewModelForRequest(){

        return{

        }
    }


    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setModules(modules): void{

        let arrayModules = Object.keys(modules).map(function(e){return modules[e]})
        this.getTemplateViewModel().modules(arrayModules);
    }

    public setTagTypesLabelNameMapping(tagTypesMapping): void{
        this.getTemplateViewModel().tagTypesLabelMapping([])
        for (const tagType of tagTypesMapping) {
            const { id, name, labelName } = tagType;
            const tagTypeViewModel = {
                id : ko.observable(id),
                name : ko.observable(name),
                labelName : ko.observable(labelName)
            };
            this.getTemplateViewModel().tagTypesLabelMapping.push(tagTypeViewModel);
        }
    }

    public onClickEditAuthorDetail(index) {

        this.caller.onClickEditAuthorDetail(index, this.getTemplateViewModel().modules())
    }

    public onClickSaveEditValue(){

        let editedModule = this.getTemplateViewModel().moduleToEdit();

        if (editedModule.permalink == null || editedModule.permalink == "") {
            alert("The permalink cannot be blank");
            return;
        }

        if (editedModule.permalink.length > 255) {
            alert("The permalink cannot be longer than 255 characters");
            return;
        }

        if(editedModule.name == null || editedModule.name == ""){
            alert("The name cannot be blank");
            return;
        }

        if (editedModule.name.length > 255) {
            alert("The name cannot be longer than 255 characters");
            return;
        }

        if(editedModule.maxItems == null || editedModule.maxItems == ""){
            alert("The max items cannot be blank");
            return;
        }

        if(editedModule.listType == null || editedModule.listType == ""){
            alert("The list type cannot be blank");
            return;
        }

        if(editedModule.tagTypes == null || editedModule.tagTypes.length == 0){
            alert("The tag type cannot be blank");
            return;
        }

        let currentDetails = this.getTemplateViewModel().modules();

        this.getTemplateViewModel().modules(currentDetails);

        this.getTemplateViewModel().editValue(null);

        this.refreshModules(this);

        this.toggleEditDialogVisibility();
    }

    protected refreshModules(huit_neuf_this){
        let modules = [];
        modules = huit_neuf_this.getTemplateViewModel().modules();

        let selector = '#' + huit_neuf_this.idElement + ' #config-item-list .img-config-item';
        let liElements = document.querySelectorAll(selector);

        let newModules = []
        liElements.forEach((element, index) => {

            let authorDetail = modules.find((i, index) => index === Number(element.id));
            if(authorDetail){
                authorDetail.position = index + 1;
                newModules.push(authorDetail);
            }
        });

        huit_neuf_this.getTemplateViewModel().modules([]);
        huit_neuf_this.getTemplateViewModel().modules(newModules);
    }

    public onClickSave(){

        this.caller.save();
    }

    public onClickCancel(){

        this.caller.cancelChanges();
    }

    public onClickAdd() {

        let arrayModules = this.getTemplateViewModel().modules();
        let newModule = {
            "name": "New Module",
            "niceName": "Module",
            "permalink": "",
            "position": arrayModules.length + 1,
            "maxItems": 1,
            listType: "bullet",
            imageOrientation: "portrait",
            tagTypes: []
        };
        arrayModules.push(newModule);
        this.getTemplateViewModel().modules(arrayModules);
        this.onClickShowPopUp(newModule);

        let titleElement = document.getElementById('edit-module-title');
        if(titleElement){
            titleElement.innerHTML = "Add Module";
        }
    }

    public onClickAddLabelNameForTagTypes(){
        //Get the current state
        const cloneTagTypesLabelMapping = ko.toJS(this.getTemplateViewModel().tagTypesLabelMapping())
        this.getTemplateViewModel().cloneTagTypesLabelMapping(cloneTagTypesLabelMapping);
        this.toggleLabelNameDialogVisibility();
    }

    public onClickSaveLabelNameTagTypesMapping(){
        this.caller.saveTagTypesLabelMapping();
    }

    protected setTagTypeFilter(idElement, tagTypes): void {

        this.getTemplateViewModel()[idElement].tagTypes(tagTypes);
    }

    public onClickShowPopUp(data){

        let clone = data;
        this.getTemplateViewModel().moduleToEdit(clone);
        this.tagTypeFilter.setTagTypeInfo(clone.tagType);
        this.getTemplateViewModel().isNewModule(!clone.permalink);
        this.toggleEditDialogVisibility();

        let titleElement = document.getElementById('edit-module-title');
        if(titleElement){
            titleElement.innerHTML = "Edit Module";
        }
    }

    public onClickHidePopUp(){

        this.tagTypeFilter.clearInput();
        this.getTemplateViewModel().isNewModule(false);
        this.getTemplateViewModel().moduleToEdit(null);
        this.toggleEditDialogVisibility();
    }

    public onClickHidePopUpForLabelName(){
        this.toggleLabelNameDialogVisibility();
        this.restoreOriginalTagTypesLabelNameMapping();
    }

    private restoreOriginalTagTypesLabelNameMapping() {
        if (this.getTemplateViewModel().cloneTagTypesLabelMapping().length > 0) {
            this.setTagTypesLabelNameMapping(this.getTemplateViewModel().cloneTagTypesLabelMapping())
        }
    }

    public toggleEditDialogVisibility() {

        document.getElementById('edit-dialog').classList.toggle('is-visible');
    }

    public toggleLabelNameDialogVisibility() {
        this.getTemplateViewModel().labelNameDialogIsShow(!this.getTemplateViewModel().labelNameDialogIsShow());
    }

    public onClickDeleteModule(data) {

        //Add js checkbox check with confirmation message before removing the module
        if(confirm("Are you sure you want to delete the module? This action cannot be reversed.")) {

            let editedModule = this.getTemplateViewModel().moduleToEdit();

            let arrayModules = this.getTemplateViewModel().modules();
            let index = arrayModules.indexOf(editedModule);

            arrayModules.splice(index, 1);
            this.getTemplateViewModel().modules(arrayModules);

            this.onClickHidePopUp();

            this.caller.deleteModule(editedModule.id);
        }
    }

    public addTagType(){

        let moduleToEdit = this.getTemplateViewModel().moduleToEdit();
        let tagTypeObj = this.tagTypeFilter.getTemplateViewModel().tagTypeObj();

        let tagTypesList = [];

        if(moduleToEdit && tagTypeObj){

            tagTypesList = moduleToEdit.tagTypes;
            if(!tagTypesList){
                tagTypesList = [];
            }

            tagTypesList.push(tagTypeObj);
        }

        moduleToEdit.tagTypes = tagTypesList;
        this.getTemplateViewModel().moduleToEdit(moduleToEdit);

        this.tagTypeFilter.clearInput();
    }

    public onClickDeleteTagType(data) {

        let moduleToEdit = this.getTemplateViewModel().moduleToEdit();
        let tagTypesList = moduleToEdit.tagTypes;
        let index = tagTypesList.indexOf(data);

        tagTypesList.splice(index, 1);
        moduleToEdit.tagTypes = tagTypesList;

        this.getTemplateViewModel().moduleToEdit(moduleToEdit);
    }

    public onChangeModuleName(data) {
        let moduleToEdit = this.getTemplateViewModel().moduleToEdit();
        let isNewModule = this.getTemplateViewModel().isNewModule();

        if (isNewModule) {
            moduleToEdit.permalink = encodeURIComponent(moduleToEdit.name.replace(/\s/g, '-').toLowerCase());
        }

        this.getTemplateViewModel().moduleToEdit(moduleToEdit);
    }

    public onChangeModuleNiceName(data) {
        let moduleToEdit = this.getTemplateViewModel().moduleToEdit();
        let isNewModule = this.getTemplateViewModel().isNewModule();

        if (isNewModule) {
            moduleToEdit.permalink = encodeURIComponent(moduleToEdit.name.replace(/\s/g, '-').toLowerCase());
        }

        this.getTemplateViewModel().moduleToEdit(moduleToEdit);
    }
    public createTagTypesLabelNameMappingFromViewModel() {

        const uniqueTagTypes =  this.getUniqueTagTypesFromModules()
        if(uniqueTagTypes.length == 0){
            return;
        }

        for (const tagType of uniqueTagTypes) {
            const tagTypeViewModel = {
                id : ko.observable(tagType.id),
                name : ko.observable(tagType.name),
                labelName : ko.observable("")
            };
            this.getTemplateViewModel().tagTypesLabelMapping.push(tagTypeViewModel);
        }
    }


    public getUniqueTagTypesFromModules(){
        const allModules = this.getTemplateViewModel().modules().filter((module) => module.tagTypes && module.tagTypes.length > 0);
        const flattenedTagTypes = allModules.flatMap((module) => module.tagTypes);
        const uniqueTagTypesMap = new Map<number, typeof flattenedTagTypes[0]>();

        flattenedTagTypes.forEach((tagType) => {
            if (!uniqueTagTypesMap.has(tagType.id)) {
                uniqueTagTypesMap.set(tagType.id, tagType);
            }
        });

        return Array.from(uniqueTagTypesMap.values());
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/configMyModules_template.ts